import React from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Box, Button, MenuItem, Select } from "@material-ui/core";
import { EN } from "../../ui/constants";
import { FormCheck, FormControl, Image } from "react-bootstrap";
import carImage from "../../images/car.png";
import { Link } from "react-router-dom";

class RegistrationForm extends React.Component {
  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  validatePassword = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^(?=.*[A-Za-z])[A-Za-z\d$@!%*#?&.-]{8,}$/.test(value)) {
      error =
        "invalid password! Password should contain 8-20 characters [a-Z,!,@,#,$,%] and should contain numbers.";
    } else if (value.length > 20) {
      error = "password should not exceed 20 characters";
    }
    return error;
  };  

  validateConfirmPassword = (password, confirmPassword) => {
    let error;
    if (password !== confirmPassword) {
      error = "Confirmation password is entered incorrectly";
    }
    return error;
  };
  render() {
    const { source, registrationUser, isLargeScreen, isMediumScreen } =
      this.props;

    return (
      <Box
        display="flex"
        width="100%"
        flexDirection={["column", "column", "column", "row"]}
        alignItems="center"
      >
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={isMediumScreen ? "none" : "block"}
          mt={[0, 0, 0, 20]}
        >
          <Box style={{ display: isLargeScreen ? "none" : "flex" }}>
            <Image src={carImage} alt="Car Image" width="100%" />
          </Box>
        </Box>
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={["block", "flex"]}
          height={["auto", "auto", "auto", "540px"]}
          p="12px 20px"
          justifyContent="center"
          alignItems="center"
        >
          <Formik
            initialValues={{
              email: "",
              password: "",
              confirm_password: "",
              source: 1,
              receive_newsletter: false,
              receive_updates: false,
            }}
            validate={(values) => {
              let errors = {
                email: this.validateEmail(values.email),
                password: this.validatePassword(values.password),
                confirm_password: this.validateConfirmPassword(
                  values.password,
                  values.confirm_password
                ),
              };

              Object.keys(errors).forEach((key) => {
                if (errors[key] === undefined) {
                  delete errors[key];
                }
              });
              return errors;
            }}
            onSubmit={(values) => {
              registrationUser(
                values.email,
                values.password,
                values.source,
                values.receive_newsletter,
                values.receive_updates
              );
            }}
          >
            {({ values, handleChange, handleSubmit, handleBlur }) => (
              <Box width={["auto", "350px"]}>
                <Form onSubmit={handleSubmit}>
                  <Box
                    className="heading-text-font"
                    color="#000"
                    fontSize="20px"
                    fontWeight="700"
                    mb={2}
                  >
                    <span style={{ color: "#E00000" }}>Sign</span> up
                  </Box>
                  <Box>
                    <Box>
                      <Box>
                        <FormControl
                          placeholder="Email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          name="email"
                          type="email"
                          variant="outlined"
                          fullWidth
                          margin="dense"
                        />
                        <ErrorMessage
                          className="errorMsg"
                          name="email"
                          component="div"
                        />
                      </Box>
                      <Box mt={2}>
                        <FormControl
                          variant="outlined"
                          placeholder="Password"
                          type="password"
                          name="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          fullWidth
                          margin="dense"
                        />
                        <ErrorMessage
                          className="errorMsg"
                          name="password"
                          component="div"
                        />
                      </Box>
                      <Box mt={2}>
                        <FormControl
                          variant="outlined"
                          placeholder="Confirm password"
                          type="password"
                          name="confirm_password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.confirm_password}
                          margin="dense"
                          fullWidth
                        />
                        <ErrorMessage
                          className="errorMsg"
                          name="confirm_password"
                          component="div"
                        />
                      </Box>
                    </Box>
                    <Box mt={2}>
                      <Field
                        variant="outlined"
                        as={Select}
                        name="source"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.source}
                        margin="dense"
                        fullWidth
                      >
                        {source.map((val, k) => (
                          <MenuItem key={k} value={val.id}>
                            {val.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </Box>
                    <Box mt={2}>
                      <Box className="formCheckLabel">
                        <FormCheck
                          name="receive_newsletter"
                          checked={values.receive_newsletter}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label="I would like to receive the Motor Events newsletter"
                        />
                      </Box>
                      <Box className="formCheckLabel">
                        <FormCheck
                          name="receive_updates"
                          checked={values.receive_updates}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label="I would like to receive updates from Motor
                      Events, including new race info & special offer"
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box bgcolor="#E00000" borderRadius={5}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      style={{ backgroundColor: "#E00000", color: "white" }}
                      type="submit"
                    >
                      {EN.create_account}
                    </Button>
                  </Box>
                  <Box display="flex" mt={2} ml={[1, 1, 0]} width="100%">
                    <Box color="black">Already have an account? </Box>
                    <Link to="/login">
                      <Box color="#E00000" pl={1}>
                        Sign in
                      </Box>
                    </Link>
                  </Box>
                </Form>
              </Box>
            )}
          </Formik>
        </Box>
      </Box>
    );
  }
}

export default RegistrationForm;
